module.exports = __webpack_public_path__ + "static/MC_steps_reemplazo_FISICA_4_B-fce44414b8f4843ea38add15c6da8b6e.gif";